<div class="dashboard">
  <app-alert-kyc-status></app-alert-kyc-status>
  @if (showFundAccountAlert) {
    <div class="alert warning-emphasis">
      <div class="row align-items-center">
        <div class="col-auto">
          <div class="row align-items-center">
            <div class="col-auto pe-1">
              <i class="iconoir-warning-triangle"></i>
            </div>
            <div class="col">
              <strong>Fund Account:</strong> Please note that physical employee cards and virtual subscription cards
              must be funded separately.
            </div>
          </div>
        </div>
        <div class="col-auto ms-auto">
          <a
            id="verifyIdentityBtn"
            routerLink="/fund-account"
            class="ms-auto btn btn-sm btn-light">
            Fund account
          </a>
        </div>
      </div>
    </div>
  }
  <div class="row mb-4 g-4">
    <div class="col">
      <app-account-balance-widget (showFundAccountAlert)="fundAccountAlert($event)"></app-account-balance-widget>
    </div>
    <div class="col">
      <app-account-balance-widget [isEmployeeCardBalance]="false"></app-account-balance-widget>
    </div>
    <div class="col">
      <app-average-spend-widget></app-average-spend-widget>
    </div>
  </div>

  <div class="row mb-4 g-4">
    <div class="col">
      <app-cards-widget></app-cards-widget>
    </div>
    <div class="col">
      <app-health-status-widget></app-health-status-widget>
    </div>
    <div class="col">
      <app-accounting-software-widget></app-accounting-software-widget>
    </div>
  </div>

  <div class="card shadow">
    <div class="card-body">
      <div class="card-title">Recent transactions</div>
      <app-table
        [columns]="columns"
        [showPagination]="false"
        [pageSize]="4"
        [getDataCallback]="getData"
        class="table-recent-transactions"
        emptyMessage="Your recent transactions will appear here.">
        <ng-template
          #dateCell
          let-value="value">
          {{ value | date: 'dd/MM/yyyy' }}<br />
          <span class="small text-black-50">{{ value | date: 'hh:mm a' }}</span>
        </ng-template>
        <ng-template
          #merchantCell
          let-value="value">
          <div class="text-overflow-ellipses">
            {{ value }}
          </div>
        </ng-template>
        <ng-template
          #categoryCell
          let-value="value">
          <div
            class="text-overflow-ellipses"
            title="{{ value.name }} {{ value.account?.code ? '(' + value.account.code + ')' : '' }}">
            {{ value.name }}
            @if (value.account?.code) {
              <span>({{ value.account.code }})</span>
            }
          </div>
        </ng-template>
        <ng-template
          #amountCell
          let-row="row"
          let-value="value">
          <span
            class="fw-semibold"
            [class.opacity-50]="row.custom_amount">
            {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          </span>
        </ng-template>
        <ng-template
          #receiptCell
          let-row="row"
          let-value="value">
          <div class="lead text-center">
            @if (value) {
              <i class="iconoir-check-circle text-success"></i>
            } @else if (row.receipt) {
              <i class="iconoir-check-circle text-success"></i>
            } @else {
              <i class="iconoir-minus-circle text-danger"></i>
            }
          </div>
        </ng-template>
      </app-table>

      <div class="text-end dash-transaction-view-all">
        <a
          id="viewAllTransactions"
          routerLink="/accounting/transactions"
          class="btn btn-sm btn-primary">
          View all
        </a>
      </div>
    </div>
  </div>
</div>
